import ObjectIdGenerator from 'app/interfaces/ObjectIdGenerator';
import { ObjectID } from 'bson';

export default class BSONObjectIdGenerator extends ObjectIdGenerator {
  /** @returns {string} */
  create = () => new ObjectID().toHexString();
}
